import React from 'react';
import { StarIcon } from 'lucide-react';
interface StarsProps {
  label?: string;
  /** Rating out of 5. Defaults to a full 5. */
  value?: number;
  /** Tailwind size classes for each star. */
  starClassName?: string;
}
export function Stars({
  label,
  value = 5,
  starClassName = 'h-4 w-4'
}: StarsProps) {
  const clamped = Math.max(0, Math.min(5, value));
  return <div className="flex items-center gap-1" role="img" aria-label={label ?? `Calificación ${clamped.toString().replace('.', ',')} de 5 estrellas`} data-id="element-232" data-mp="2ouyv4jpt1ijg">
      {Array.from({
      length: 5
    }).map((_, i) => {
      const fill = Math.max(0, Math.min(1, clamped - i));
      return <span key={i} className={`relative inline-block ${starClassName}`} aria-hidden="true" data-id="element-233" data-mp="37n9tc09iksb8" data-mpi={i}>
            <StarIcon className={`absolute inset-0 ${starClassName} text-brand-gold/30`} data-id="element-234" data-mp="37pmbadf9v2oa" />
            <span className="absolute inset-0 overflow-hidden" style={{
          width: `${fill * 100}%`
        }} data-id="element-235" data-mp="214urwdgj3ksz">
              <StarIcon className={`${starClassName} fill-brand-gold text-brand-gold`} data-id="element-236" data-mp="k03tndufa05p" />
            </span>
          </span>;
    })}
    </div>;
}